/**
 * Async loop
 *
 * @param {Object[]} array
 * @param {Function} callback
 * @returns {Promise<void>}
 */
export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export const waitFor = (ms) => new Promise(v => setTimeout(v, ms));

/**
 * Load requests one by one
 *
 * @param {Object[]} requests  -  [ { func: () => {}, args = ['param1', 'param2'] }]
 * @returns {Promise<void>}
 */
export const loadRequests = (requests = []) => {
  const start = async () => {
    await asyncForEach(requests, async (data) => {

      if (typeof data === 'function') {
        await data();
      } else if (data.hasOwnProperty('func')
        && typeof data.func === 'function'
        && data.hasOwnProperty('args')
        && Array.isArray(data.args)
      ) {
        await data.func(...data.args);
      }

    });
  };

  return start();
};
